import { useState } from "react";
import { createPortal } from "react-dom";
import { Download, Share, X, Smartphone, Monitor, MoreVertical, CheckCircle2 } from "lucide-react";
import { useInstallPrompt } from "../lib/pwa";

const Step = ({ n, children }) => (
  <li className="flex gap-2 text-xs text-[#94A3B8]"><span className="shrink-0 h-5 w-5 rounded-full bg-[#3B82F6]/15 text-[#3B82F6] font-bold text-[10px] flex items-center justify-center">{n}</span><span>{children}</span></li>
);

export const InstallGuide = ({ onClose }) => {
  const { canInstall, install } = useInstallPrompt();
  return createPortal(
    <div data-testid="install-guide" className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm p-3" onClick={onClose}>
      <div className="w-full max-w-lg bg-[#121724] border border-[#2A364F] rounded-xl p-5 shadow-2xl fade-up max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-center gap-3">
            <img src="/icons/icon-192.png" alt="Rotarsi Al Sat Botu" className="h-12 w-12 rounded-xl" />
            <div><h3 className="font-head text-base font-extrabold">Rotarsi Al Sat Botu'nu uygulama olarak yükle</h3><p className="text-[11px] text-[#64748B]">Mağaza veya kurulum dosyası yok — bu site doğrudan cihazınıza uygulama olarak eklenir.</p></div>
          </div>
          <button data-testid="install-guide-close" onClick={onClose} className="text-[#64748B] hover:text-[#F1F5F9]"><X className="h-5 w-5" /></button>
        </div>
        {canInstall && (
          <button data-testid="install-guide-install-button" onClick={install} className="w-full mb-4 flex items-center justify-center gap-2 bg-[#3B82F6] hover:bg-[#2563EB] text-white font-semibold rounded-lg px-4 py-2.5 text-sm"><Download className="h-4 w-4" /> Şimdi Yükle (tek tık)</button>
        )}
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="space-y-2">
            <p className="text-xs font-bold flex items-center gap-1.5"><Smartphone className="h-3.5 w-3.5 text-[#10B981]" /> Android (Chrome)</p>
            <ol className="space-y-1.5"><Step n="1">Sağ üstte <MoreVertical className="inline h-3 w-3" /> menüye dokunun</Step><Step n="2"><b>Uygulamayı yükle</b> / <b>Ana ekrana ekle</b></Step><Step n="3"><b>Yükle</b> → ikon ana ekranda</Step></ol>
          </div>
          <div className="space-y-2">
            <p className="text-xs font-bold flex items-center gap-1.5"><Smartphone className="h-3.5 w-3.5 text-[#F1F5F9]" /> iPhone / iPad (Safari)</p>
            <ol className="space-y-1.5"><Step n="1">Alttaki <Share className="inline h-3 w-3" /> <b>Paylaş</b> düğmesi</Step><Step n="2"><b>Ana Ekrana Ekle</b></Step><Step n="3">Sağ üstte <b>Ekle</b></Step></ol>
          </div>
          <div className="space-y-2 sm:col-span-2">
            <p className="text-xs font-bold flex items-center gap-1.5"><Monitor className="h-3.5 w-3.5 text-[#3B82F6]" /> Windows / Mac (Chrome, Edge)</p>
            <ol className="space-y-1.5"><Step n="1">Adres çubuğunun sağındaki <Download className="inline h-3 w-3" /> <b>Yükle</b> simgesine tıklayın (veya menü → <b>Uygulamayı yükle</b>)</Step><Step n="2"><b>Yükle</b> → Rotarsi Al Sat Botu kendi penceresinde açılır, Başlat menüsü / Dock'a eklenir</Step></ol>
          </div>
        </div>
        <p className="mt-4 text-[11px] text-[#64748B] flex items-start gap-1.5"><CheckCircle2 className="h-3.5 w-3.5 text-[#10B981] shrink-0 mt-0.5" /><span>Yükledikten sonra Ayarlar → <b>Bildirimleri Aç</b> ile işlem açılış/kapanış bildirimlerini telefona alabilirsiniz.</span></p>
      </div>
    </div>,
    document.body
  );
};

export const InstallButton = () => {
  const { canInstall, install, standalone } = useInstallPrompt();
  const [open, setOpen] = useState(false);
  if (standalone) return null;
  return (
    <>
      <button
        data-testid="pwa-install-button"
        onClick={() => (canInstall ? install() : setOpen(true))}
        className="flex items-center gap-1.5 text-xs font-semibold text-[#3B82F6] border border-[#3B82F6]/40 bg-[#3B82F6]/10 hover:bg-[#3B82F6]/20 rounded-full px-3 py-1.5 transition-colors"
      >
        <Download className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Uygulamayı</span> Yükle
      </button>
      {open && <InstallGuide onClose={() => setOpen(false)} />}
    </>
  );
};
